export class ConfigService {
  public baseUrl: string = 'https://app.i-markt.ch';
  public baseVersion: string = 'v1';
  public anonymousDomain: string = '@i-markt-anon.com';

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/providers/config.service.ts